import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../app/login/Login.css'
const Footer = () => {
    return (
        <>

            <div
                className="w3-panel w3-padding-16 w3-card-4 w3-center reliable-theme"
                style={{ marginBottom: 0, backgroundColor: "#2C3539", color: "#fff" }}
            >
                <p>
                    Copyright © 2022 Reliable Institute Kota. All Rights Reserved | CALL US :{" "}
                    <a
                        className="tel_link"
                        href="tel: 0744-3535544"
                        style={{ fontWeight: "bold" }}
                    >
                        0744-3535544
                    </a>
                </p>
            </div>
        </>
    )
}

export default Footer